import { type ILogger } from '@cian/logger/shared';

const domain = '@/packages/utils/reloadHeader';

export function reloadHeader(logger: ILogger): boolean {
  window.__reloadHeader__?.();

  if (window.__reloadHeader__) {
    logger.info('При авторизации шапка успешно перезагрузилась', { domain });
  } else {
    logger.warning(
      'При авторизации пользователя шапка не перезагрузилась, так как не было функции перезагрузки шапки',
      { domain },
    );
  }

  return !!window.__reloadHeader__;
}
